// extracted by mini-css-extract-plugin
export default {"price":"feed-item-price_price__JmEur"};